import { authSelectors } from 'ducks/auth'
import { viewModeSelectors } from 'ducks/viewMode'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'
import { ALLOW_ANONYMOUS_CHAT } from 'voice/AppStateManager'

export const useAdaActive = (ignoreVoiceAndText: boolean = false) => {
  const isUserLite = useSelector(viewModeSelectors.isUserLite)

  const userId = useSelector(authSelectors.getCurrentUserId)
  const enoughAuth = !!userId || !!ALLOW_ANONYMOUS_CHAT

  const voiceEnabled = !!useFeatureFlag('ada_voice', 'on')
  const textEnabled = !!useFeatureFlag('ada_text', 'on')

  const voiceActive = voiceEnabled && enoughAuth
  const textActive = textEnabled && enoughAuth

  const voiceAndTextCheckSucceeded = (voiceEnabled && textEnabled) || ignoreVoiceAndText

  const active = voiceAndTextCheckSucceeded && !isUserLite

  return { active, voiceActive, textActive, voiceEnabled, textEnabled }
}
